(function () {
  const galleries = document.querySelectorAll("[data-product-media-gallery]");

  galleries.forEach((gallery) => {
    const carouselNode = gallery.querySelector("[data-media-carousel]");
    const thumbnails = gallery.querySelectorAll("[data-media-thumbnail]");
    const dots = gallery.querySelectorAll("[data-media-dot]");
    const prevButton = gallery.querySelector("[data-media-prev]");
    const nextButton = gallery.querySelector("[data-media-next]");
    const startIndex = parseInt(
      gallery.getAttribute("data-selected-index") || "0",
      10,
    );

    if (!carouselNode || !window.EmblaCarousel) return;

    const embla = window.EmblaCarousel(carouselNode, {
      loop: false,
      align: "start",
      skipSnaps: false,
      containScroll: "trimSnaps",
      startIndex,
    });

    function updateButtons() {
      if (prevButton) prevButton.disabled = !embla.canScrollPrev();
      if (nextButton) nextButton.disabled = !embla.canScrollNext();
    }

    function updateDots() {
      const selectedIndex = embla.selectedScrollSnap();
      dots.forEach((dot) => {
        const index = parseInt(dot.getAttribute("data-media-dot"), 10);
        const isActive = index === selectedIndex;
        dot.classList.toggle("before:bg-primary", isActive);
        dot.classList.toggle("before:bg-disabled", !isActive);
      });
    }

    function updateThumbnails() {
      const selectedIndex = embla.selectedScrollSnap();
      thumbnails.forEach((t) => {
        const index = parseInt(t.getAttribute("data-media-thumbnail"), 10);
        const isActive = index === selectedIndex;
        t.classList.toggle("border-accent", isActive);
        t.classList.toggle("border-transparent", !isActive);
        if (isActive) {
          const container = t.parentElement;
          if (container) {
            const isVertical = container.scrollHeight > container.clientHeight;
            if (isVertical) {
              const offset = t.offsetTop - container.offsetTop;
              container.scrollTo({
                top: offset - container.clientHeight / 2 + t.offsetHeight / 2,
                behavior: "smooth",
              });
            } else {
              const offset = t.offsetLeft - container.offsetLeft;
              container.scrollTo({
                left: offset - container.clientWidth / 2 + t.offsetWidth / 2,
                behavior: "smooth",
              });
            }
          }
        }
      });
      updateButtons();
      updateDots();
    }

    embla.on("select", updateThumbnails);
    embla.on("reInit", updateThumbnails);
    updateThumbnails();

    dots.forEach((dot) => {
      dot.addEventListener("click", function () {
        const index = parseInt(this.getAttribute("data-media-dot"), 10);
        embla.scrollTo(index);
      });
    });

    if (prevButton) {
      prevButton.addEventListener("click", () => embla.scrollPrev());
    }
    if (nextButton) {
      nextButton.addEventListener("click", () => embla.scrollNext());
    }

    thumbnails.forEach((thumbnail) => {
      thumbnail.addEventListener("click", function () {
        const index = parseInt(this.getAttribute("data-media-thumbnail"), 10);
        embla.scrollTo(index);
      });
    });

    function getSizedUrl(src, width) {
      try {
        const url = new URL(src);
        url.searchParams.set("width", String(width));
        return url.toString();
      } catch {
        return src;
      }
    }

    function swapImage(container, src, width) {
      const img = container.querySelector("img");
      if (!img) return;
      img.src = getSizedUrl(src, width);
      img.srcset = "";
    }

    const lgQuery = window.matchMedia('(min-width: 1024px)');
    const zoomSlides = carouselNode.querySelectorAll('[data-zoom-slide]');
    zoomSlides.forEach((slide, index) => {
      const img = slide.querySelector('img');
      if (!img) return;

      slide.addEventListener('mouseenter', () => {
        if (!lgQuery.matches) return;
        img.style.cursor = 'zoom-in';
      });

      slide.addEventListener('mousemove', (e) => {
        if (!lgQuery.matches) return;
        const rect = slide.getBoundingClientRect();
        const x = ((e.clientX - rect.left) / rect.width) * 100;
        const y = ((e.clientY - rect.top) / rect.height) * 100;
        img.style.transition = 'transform 0.15s ease';
        img.style.transform = 'scale(2)';
        img.style.transformOrigin = `${x }% ${ y }%`;
      });

      slide.addEventListener('mouseleave', () => {
        img.style.cursor = '';
        img.style.transition = 'transform 0.15s ease';
        img.style.transform = '';
        img.style.transformOrigin = '50% 50%';
      });

      slide.addEventListener('click', () => {
        if (!window.PhotoSwipe) return;
        zoomSlides.forEach((s) => {
          const zoomImg = s.querySelector('img');
          if (zoomImg) {
            zoomImg.style.transform = '';
            zoomImg.style.transformOrigin = '50% 50%';
          }
        });
        const items = Array.from(zoomSlides).map((s) => ({
          src: s.getAttribute('data-pswp-src'),
          width: parseInt(s.getAttribute('data-pswp-width') || '1200', 10),
          height: parseInt(s.getAttribute('data-pswp-height') || '1200', 10),
          msrc: s.querySelector('img') ? s.querySelector('img').src : undefined
        }));
        const pswp = new window.PhotoSwipe({ dataSource: items, index });
        pswp.init();
      });
    });

    // Listen for variant changes from the buy box
    document.addEventListener("variant:changed", (event) => {
      const detail = event.detail || {};
      const { mediaId } = detail;
      const { imageSrc } = detail;
      if (!mediaId || !imageSrc) return;

      // Swap the variant slide image
      const variantSlide = carouselNode.querySelector("[data-variant-slide]");
      if (variantSlide) {
        variantSlide.setAttribute("data-media-id", String(mediaId));
        swapImage(variantSlide, imageSrc, 1200);
        variantSlide.setAttribute('data-pswp-src', getSizedUrl(imageSrc, 1800));
        const variantImg = variantSlide.querySelector('img');
        if (variantImg) {
          variantImg.addEventListener('load', () => {
            variantSlide.setAttribute('data-pswp-width', String(variantImg.naturalWidth));
            variantSlide.setAttribute('data-pswp-height', String(variantImg.naturalHeight));
          }, { once: true });
        }
      }

      // Swap the variant thumbnail image
      const variantThumb = gallery.querySelector("[data-variant-thumbnail]");
      if (variantThumb) {
        variantThumb.setAttribute("data-media-id", String(mediaId));
        swapImage(variantThumb, imageSrc, 180);
      }

      // Scroll to the first slide (the variant image)
      embla.scrollTo(0);
    });
  });
})();
 